import { useState } from 'react';
import { bool, func, number, shape, string } from 'prop-types';
import { connect } from 'react-redux';
import { CloseButton } from '@fff-web/fff-ui-shared';
import { events, trackRefillsCanceled } from '../../../../utils/analytics';
import CancelSubscriptionConfirmation from '../CancelSubscriptionConfirmation/CancelSubscriptionConfirmation';
import DetailProduct from '../DetailProduct';
import SubscriptionCancelled from '../SubscriptionCancelled/SubscriptionCancelled';
import * as styles from './DesktopProductModal.module.scss';

const DesktopProductModal = ({
  onCloseModal,
  subscription,
  user,
  subscriptionsQuantity,
  isRefillOnly,
}) => {
  const [cancelling, setCancelling] = useState(false);
  const [subscriptionCancelled, setSubscriptionCancelled] = useState(false);

  const onCancelAction = () => {
    setCancelling(true);
    trackRefillsCanceled(user, null, subscription, events.START_CANCEL);
  };
  const onNeverMind = () => setCancelling(false);
  const onSubscriptionCancelled = () => {
    setSubscriptionCancelled(true);
    trackRefillsCanceled(user, null, subscription, events.CONFIRM_CANCEL);
  };

  return (
    <div data-testid="desktop-product-modal" className={styles.container}>
      <CloseButton onClick={onCloseModal} />
      {subscription && !cancelling && (
        <DetailProduct subscription={subscription} onCancelAction={onCancelAction} />
      )}
      {subscription && cancelling && !subscriptionCancelled && (
        <CancelSubscriptionConfirmation
          subscriptionUuid={subscription.productId}
          cadenceType={subscription.cadenceType}
          onNeverMind={onNeverMind}
          onSubscriptionCancelled={onSubscriptionCancelled}
          isLastRefillProduct={subscriptionsQuantity === 1}
          isRefillOnly={isRefillOnly}
        />
      )}
      {subscriptionCancelled && (
        <SubscriptionCancelled
          onReturn={onCloseModal}
          isRefillProduct={subscription?.cadenceType === 'NINETY_DAYS'}
          isLastRefillProduct={subscriptionsQuantity === 0}
          nextRenewalDate={subscription && subscription.nextRenewalDate}
          isRefillOnly={isRefillOnly}
        />
      )}
    </div>
  );
};

DesktopProductModal.propTypes = {
  subscription: shape({
    productId: string,
    cadenceType: string,
    brand: string,
    name: string,
    quantity: number,
    nextRenewalDate: string,
  }).isRequired,
  user: shape({}).isRequired,
  onCloseModal: func.isRequired,
  subscriptionsQuantity: number.isRequired,
  isRefillOnly: bool.isRequired,
};

const mapStateToProps = (state) => ({
  user: state.user,
  isMobile: state.view.isMobile,
});

export default connect(mapStateToProps)(DesktopProductModal);
